<template>
  <div style="position: relative; display: inline-block; width: 54px; height: 54px;">
    <!-- SVG 圆环 -->
    <svg width="54" height="54" class="osvg" v-show="props.isActivity">
      <!-- 灰色圆环 (底层) -->
      <circle
        class="oround-bg"
        cx="27"
        cy="27"
        r="25"
        fill="transparent"
        stroke-width="2"
        stroke="grey"
      ></circle>

      <!-- 白色进度条 (上层) -->
      <circle
        class="oround"
        cx="27"
        cy="27"
        r="25"
        fill="transparent"
        stroke-width="2"
        stroke="white"
        :style="{ strokeDashoffset: dashOffset }"
      ></circle>
    </svg>

    <!-- 中间的 "." -->
    <div
      style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 7px;
        width: 7px;
        border-radius: 50%;
        background-color: #afafaf;
        opacity: 75%;
      "
    >
    </div>
  </div>
</template>

<script setup>
import { ref,defineProps,watch } from "vue";

const props = defineProps({
  isActivity: {
    type: Boolean,
    required: true,
  }
});

// 圆的周长（半径为25）
const totalLength = 2 * Math.PI * 25; // 半径为25
const dashOffset = ref(totalLength); // 初始状态：白色覆盖在顶部
const isWhiteCovering = ref(true); // 当前是否白色覆盖灰色
let interval = ""
const stopAnimation = () => {
  clearInterval(interval);
  dashOffset.value = totalLength
};

const startAnimation = () => {
  const duration = 5000; // 每阶段动画总时长为5秒
  const frameRate = 60; // 每秒60帧
  const step = totalLength / (duration / (1000 / frameRate)); // 每一帧的移动步长
  let progress = 0;

  interval = setInterval(() => {
    progress += step;

    // if (isWhiteCovering.value) {
      // 白色覆盖灰色
    dashOffset.value = Math.max(totalLength - progress, 0); // 减少偏移量
    // } else {
    //   // 灰色覆盖白色
    //   dashOffset.value = Math.min(progress, totalLength); // 从顶部重新覆盖白色
    // }

    // 动画完成时，切换阶段
    if (progress >= totalLength) {
      clearInterval(interval);
      progress = 0; // 重置进度
      isWhiteCovering.value = !isWhiteCovering.value; // 切换覆盖状态
      setTimeout(() => {
        startAnimation(); // 重新开始动画
      }, 500); // 添加短暂停留
    }
  }, 1000 / frameRate);
};

watch(
  () => props.isActivity,
  (newVal) => {
    if (newVal) {
      startAnimation(); // 如果 isActivity 为 true，则启动动画
    } else {
      stopAnimation(); // 如果 isActivity 为 false，则停止动画
    }
  },
  { immediate: true } // 立即执行一次，以确保在组件挂载时根据初始值判断是否启动动画
);

</script>

<style scoped>
/* 灰色底层圆环 */
.oround-bg {
  stroke-dasharray: 157; /* 总长度（半径25） */
  stroke-dashoffset: 0; /* 永远显示 */
}

/* 白色进度条 */
.oround {
  stroke-dasharray: 157; /* 总长度（半径25） */
  stroke-dashoffset: 157; /* 从全覆盖开始 */
  /*transition: stroke-dashoffset 0.1s linear; !* 平滑过渡效果 *!*/
}
</style>
